import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { RequestCreditPageRoutingModule } from './request-credit-routing.module';
import { RequestCreditPage } from './request-credit.page';
import { OrderAndProductOptionsDesktopComponent } from './components/order-and-product-options/order-and-product-options-desktop/order-and-product-options-desktop.component';
import { OrderOptionsTouchComponent } from './components/order-and-product-options/order-and-product-options-touch/order-options-touch/order-options-touch.component';
import { ProductOptionsTouchComponent } from './components/order-and-product-options/order-and-product-options-touch/product-options-touch/product-options-touch.component';
import { IssueAndIssueDetailsDesktopComponent } from './components/issue-and-issue-details/issue-and-issue-details-desktop/issue-and-issue-details-desktop.component';
import { IssueOptionsTouchComponent } from './components/issue-and-issue-details/issue-and-issue-details-touch/issue-options-touch/issue-options-touch.component';
import { IssueDetailsOptionsTouchComponent } from './components/issue-and-issue-details/issue-and-issue-details-touch/issue-details-options-touch/issue-details-options-touch.component';
import { EffectsModule } from '@ngrx/effects';
import { ClientRequestCreditEffects } from './effects/client-request-credit.effects';
import { AcceptedFileTypesPopoverComponent } from './components/accepted-file-types-popover/accepted-file-types-popover.component';
import { SharedModule } from '@shared/shared.module';
import { PickUpQuestionModalComponent } from './components/pick-up-request-modals/pick-up-question-modal/pick-up-question-modal.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RequestCreditPageRoutingModule,
    SharedModule,
    EffectsModule.forFeature([ClientRequestCreditEffects]),
  ],
  declarations: [
    RequestCreditPage,
    OrderAndProductOptionsDesktopComponent,
    OrderOptionsTouchComponent,
    ProductOptionsTouchComponent,
    IssueAndIssueDetailsDesktopComponent,
    IssueOptionsTouchComponent,
    IssueDetailsOptionsTouchComponent,
    AcceptedFileTypesPopoverComponent,
    PickUpQuestionModalComponent,
  ],
  exports: [AcceptedFileTypesPopoverComponent],
})
export class RequestCreditPageModule {}
